<app-card [title]="'user.editUser.labels.basicInfo'" titleSize="large">
    <ng-template #content>
        <div class="input-grid-gaps grid-6col gap-y-6">
            <div class="fr-2 flex justify-content-center">
                <app-input-file-btn
                    [owner]="'user_' + user()?.id"
                    [replaceByOwner]="true"
                    (uploaded)="avatarUpload.emit($event)">
                    <app-avatar
                        size="xxxlarge"
                        [initials]="user() | personInitials"
                        [src]="user()?.image">
                    </app-avatar>
                </app-input-file-btn>
            </div>
            <div class="fr-4 input-grid-gaps grid-1col gap-y-6">
                <app-email-input
                    id="email"
                    autocorrect="off" spellcheck="false"
                    [label]="'inputs.email' | translate"
                    [disabled]="!canEdit()"
                    [form]="form()">
                </app-email-input>
                @if (!isProfileSettings()) {
                    <app-password-input
                        [form]="passwordForm()"
                        [disabled]="!canEdit()"
                        [userForPassword]="user() ? { name: user()?.name, surname: user()?.surname } : null">
                    </app-password-input>

                    <app-check-input
                        id="active"
                        label="user.fields.active"
                        [disabled]="!canEdit()"
                        [form]="form()">
                    </app-check-input>
                }
            </div>
            <app-text-input
                class="fr-3"
                id="titleBeforeName"
                [disabled]="!canEdit()"
                [form]="form()">
            </app-text-input>
            <div class="fr-3"></div>
            <app-text-input
                class="fr-3"
                id="name"
                [disabled]="!canEdit()"
                [form]="form()">
            </app-text-input>
            <app-text-input
                class="fr-3"
                id="surname"
                [disabled]="!canEdit()"
                [form]="form()">
            </app-text-input>
            <app-text-input
                class="fr-3"
                id="titleAfterName"
                [disabled]="!canEdit()"
                [form]="form()">
            </app-text-input>
            <app-select-input
                id="sex"
                label="user.common.sex.label"
                valueKey="value"
                [form]="form()"
                class="fr-3"
                [staticOptions]="userSexToEnumOptions"
                [disabled]="!canEdit()">
            </app-select-input>
        </div>
    </ng-template>
</app-card>
